import React from "react";
import ReactDOM from "react-dom";
import logoLumos from "../../../assets/img/logo_lumos.png";
import countriesData from "../../../Country.json";
import LanguageSelector from "../../LanguageSelector";

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCountryDropdown: false,
      dropdownPosition: { top: 0, left: 0 },
    };
  }

  // Normalizar os dados do JSON para o formato usado no componente
  getCountries = () => {
    return countriesData.map((country) => ({
      code: country.code,
      name: country.name,
      dialCode: country.dial_code,
      flag: country.emoji,
    }));
  };

  getDefaultCountry = () => {
    const countries = this.getCountries();
    return countries.find((c) => c.code === "US") || countries[0];
  };

  getCurrentCountry = () => {
    const countries = this.getCountries();
    const countryCode = this.props.data.countryCode || "US";
    return (
      countries.find((c) => c.code === countryCode) || this.getDefaultCountry()
    );
  };

  componentDidMount() {
    // Definir país padrão se não existir
    if (!this.props.data.countryCode) {
      const defaultCountry = this.getDefaultCountry();
      this.props.onInputChange("step1", "countryCode", defaultCountry.code);
      this.props.onInputChange(
        "step1",
        "countryDialCode",
        defaultCountry.dialCode,
      );
    }

    // Adicionar listener para fechar dropdown ao clicar fora
    // Usar capture phase para garantir que capture antes de outros handlers
    document.addEventListener("mousedown", this.handleClickOutside, true);
    document.addEventListener("touchstart", this.handleClickOutside, true);
    document.addEventListener("click", this.handleClickOutside, true);

    // Forçar inputs a serem clicáveis após montagem
    setTimeout(() => {
      this.enableInputs();
      this.setupCheckboxListener();
    }, 0);

    setTimeout(() => {
      this.enableInputs();
      this.startInputKeepAlive();
      this.setupCheckboxListener();
    }, 100);

    setTimeout(() => {
      this.enableInputs();
      this.setupCheckboxListener();
    }, 500);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, true);
    document.removeEventListener("touchstart", this.handleClickOutside, true);
    document.removeEventListener("click", this.handleClickOutside, true);
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }
    // Remover listeners do checkbox se existirem
    if (this.containerRef) {
      const checkbox = this.containerRef.querySelector(
        'input[type="checkbox"]',
      );
      if (checkbox && checkbox._wizardOnChange) {
        checkbox.removeEventListener("change", checkbox._wizardOnChange, true);
        checkbox.removeEventListener("click", checkbox._wizardOnChange, true);
      }
    }
  }

  handleClickOutside = (event) => {
    if (!this.state.showCountryDropdown) return;

    const dropdown = document.querySelector(".country-dropdown-portal");
    const isClickInsideSelector =
      this.countryDropdownRef && this.countryDropdownRef.contains(event.target);
    const isClickInsideDropdown = dropdown && dropdown.contains(event.target);

    // Se o clique não foi dentro do seletor nem do dropdown, fechar
    if (!isClickInsideSelector && !isClickInsideDropdown) {
      this.setState({ showCountryDropdown: false });
    }
  };

  toggleCountryDropdown = (e) => {
    e.stopPropagation();
    const isOpening = !this.state.showCountryDropdown;

    if (isOpening && this.countryDropdownRef) {
      const rect = this.countryDropdownRef.getBoundingClientRect();
      const isMobile = window.innerWidth <= 768;

      let top = rect.bottom + window.scrollY + 4;
      let left = rect.left + window.scrollX;

      // Ajustar posicionamento no mobile
      if (isMobile) {
        // Centralizar horizontalmente no mobile
        left = 20;

        // Calcular espaço disponível abaixo e acima
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        const dropdownMinHeight = 300;
        // Altura máxima baseada no espaço disponível, garantindo margem de segurança
        const dropdownMaxHeight = Math.min(
          500,
          Math.max(spaceBelow, spaceAbove) - 40,
        );

        // Se houver mais espaço abaixo, posicionar abaixo
        if (spaceBelow >= dropdownMinHeight || spaceBelow > spaceAbove) {
          top = rect.bottom + window.scrollY + 4;
          // Garantir que não ultrapasse a parte inferior da tela
          const maxTop =
            window.innerHeight + window.scrollY - dropdownMaxHeight - 20;
          if (top > maxTop) {
            top = maxTop;
          }
        } else {
          // Posicionar acima se houver mais espaço
          top = rect.top + window.scrollY - dropdownMaxHeight - 4;
          // Garantir que não ultrapasse a parte superior da tela
          if (top < window.scrollY + 20) {
            top = window.scrollY + 20;
          }
        }
      }

      this.setState({
        showCountryDropdown: true,
        dropdownPosition: {
          top: top,
          left: left,
        },
      });
    } else {
      this.setState((prevState) => ({
        showCountryDropdown: !prevState.showCountryDropdown,
      }));
    }
  };

  selectCountry = (country) => {
    this.props.onInputChange("step1", "countryCode", country.code);
    this.props.onInputChange("step1", "countryDialCode", country.dialCode);
    this.setState({ showCountryDropdown: false });
  };

  setupCheckboxListener = () => {
    if (!this.containerRef) return;

    const checkbox = this.containerRef.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    // Remover listeners antigos para evitar duplicatas
    const oldOnChange = checkbox._wizardOnChange;
    if (oldOnChange) {
      checkbox.removeEventListener("change", oldOnChange);
      checkbox.removeEventListener("click", oldOnChange);
    }

    // Criar novo handler
    const handleCheckboxChange = (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();
      const checked = e.target.checked;
      this.props.onInputChange("step1", "consentimento", checked);

      // Scroll para o botão quando o checkbox for marcado
      if (checked) {
        this.scrollToButton();
      }
    };

    // Salvar referência para poder remover depois
    checkbox._wizardOnChange = handleCheckboxChange;

    // Adicionar listener diretamente no DOM com capture phase
    checkbox.addEventListener("change", handleCheckboxChange, true);
    checkbox.addEventListener("click", handleCheckboxChange, true);

    // Garantir que o checkbox não esteja desabilitado
    checkbox.disabled = false;
    checkbox.removeAttribute("disabled");
    checkbox.style.pointerEvents = "auto";
    checkbox.style.cursor = "pointer";
  };

  componentDidUpdate() {
    // Garantir que inputs permaneçam clicáveis após updates
    setTimeout(() => {
      this.enableInputs();
      // Garantir que o botão esteja no estado correto após atualização
      if (this.containerRef) {
        const button = this.containerRef.querySelector('button[type="submit"]');
        if (button) {
          const consentimento = this.props.data.consentimento;
          if (consentimento && button.disabled) {
            button.disabled = false;
            button.removeAttribute("disabled");
          }
          button.style.pointerEvents = "auto";
          button.style.cursor = consentimento ? "pointer" : "not-allowed";
        }
      }
    }, 0);
  }

  startInputKeepAlive = () => {
    // Intervalo para manter inputs sempre habilitados
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }

    this.inputKeepAliveInterval = setInterval(() => {
      if (!this.containerRef) return;
      const inputs = this.containerRef.querySelectorAll(
        'input[type="text"], input[type="email"], input[type="tel"]',
      );
      inputs.forEach((input) => {
        if (input.disabled) {
          input.disabled = false;
          input.removeAttribute("disabled");
        }
        input.style.pointerEvents = "auto";
        input.style.cursor = "text";
      });

      // Garantir que checkbox e botão também funcionem
      const checkbox = this.containerRef.querySelector(
        'input[type="checkbox"]',
      );
      if (checkbox) {
        checkbox.style.pointerEvents = "auto";
        checkbox.style.cursor = "pointer";
        checkbox.disabled = false;
        checkbox.removeAttribute("disabled");

        // Garantir que os listeners estejam ativos
        if (!checkbox._wizardOnChange) {
          this.setupCheckboxListener();
        }
      }

      const button = this.containerRef.querySelector('button[type="submit"]');
      if (button) {
        // Garantir que o botão só fique desabilitado se o consentimento realmente for false
        const consentimento = this.props.data.consentimento;
        if (consentimento && button.disabled) {
          button.disabled = false;
          button.removeAttribute("disabled");
        }
        button.style.pointerEvents = "auto";
        button.style.cursor = consentimento ? "pointer" : "not-allowed";
      }
    }, 100);
  };

  enableInputs = () => {
    if (!this.containerRef) return;

    const inputs = this.containerRef.querySelectorAll(
      'input[type="text"], input[type="email"], input[type="tel"]',
    );
    inputs.forEach((input) => {
      // GARANTIR que o input NUNCA esteja desabilitado
      input.disabled = false;
      input.readOnly = false;
      input.removeAttribute("disabled");
      input.removeAttribute("readonly");

      // Forçar estilos
      input.style.pointerEvents = "auto";
      input.style.cursor = "text";
      input.style.zIndex = "999999";
      input.style.position = "relative";
      input.style.opacity = "1";
      input.style.userSelect = "text";
      input.style.webkitUserSelect = "text";
    });
  };

  handleInputChange = (field, value) => {
    this.props.onInputChange("step1", field, value);
  };

  handleInputFocus = (e) => {
    e.target.style.pointerEvents = "auto";
    e.target.style.cursor = "text";
    e.target.focus();
  };

  scrollToButton = () => {
    setTimeout(() => {
      const button = this.containerRef?.querySelector('button[type="submit"]');
      if (button) {
        button.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }, 100);
  };

  handleCheckboxChange = (e) => {
    e.stopPropagation();
    e.stopImmediatePropagation();
    const checked = e.target.checked;
    this.props.onInputChange("step1", "consentimento", checked);

    // Scroll para o botão quando o checkbox for marcado
    if (checked) {
      this.scrollToButton();
    }
  };

  handleContinue = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.data.consentimento) {
      this.props.onNext();
    }
  };

  render() {
    const { data, t } = this.props;
    // Se t não foi passado como prop, usar função padrão que retorna a chave
    const translate = t || ((key) => key);

    return (
      <div
        className="step-container"
        ref={(ref) => {
          this.containerRef = ref;
        }}
        style={{ pointerEvents: "auto" }}
      >
        <div className="wizard-logo-container">
          <img src={logoLumos} alt="Lumos" className="wizard-logo" />
        </div>
        <div className="step-header">
          <h1 className="step-title">{translate("step1Title")}</h1>
          <p className="step-subtitle">{translate("step1Subtitle")}</p>
        </div>

        {/* Indicador de Progresso */}
        <div className="progress-indicator">
          {[1, 2, 3].map((step) => (
            <div
              key={step}
              className={`progress-bar ${
                step <= this.props.currentStep ? "active" : ""
              }`}
            />
          ))}
        </div>

        <form
          className="step-form"
          onSubmit={this.handleContinue}
          style={{
            pointerEvents: "auto",
            position: "relative",
            zIndex: 999999,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="form-group">
            <label className="form-label">{translate("fullName")}</label>
            <input
              type="text"
              className="form-input"
              value={data.nomeCompleto}
              onChange={(e) =>
                this.handleInputChange("nomeCompleto", e.target.value)
              }
              onFocus={this.handleInputFocus}
              onClick={(e) => {
                e.stopPropagation();
                e.target.focus();
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.target.focus();
              }}
              style={{
                pointerEvents: "auto",
                cursor: "text",
                zIndex: 999999,
                position: "relative",
              }}
              required
              readOnly={false}
              disabled={false}
              autoComplete="off"
              ref={(input) => {
                if (input) {
                  input.disabled = false;
                  input.removeAttribute("disabled");
                }
              }}
            />
          </div>

          <div className="form-group">
            <label className="form-label">{translate("email")}</label>
            <input
              type="email"
              className="form-input"
              value={data.email}
              onChange={(e) => this.handleInputChange("email", e.target.value)}
              onFocus={this.handleInputFocus}
              onClick={(e) => {
                e.stopPropagation();
                e.target.focus();
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.target.focus();
              }}
              style={{
                pointerEvents: "auto",
                cursor: "text",
                zIndex: 999999,
                position: "relative",
              }}
              required
              readOnly={false}
              disabled={false}
              autoComplete="off"
              ref={(input) => {
                if (input) {
                  input.disabled = false;
                  input.removeAttribute("disabled");
                }
              }}
            />
          </div>

          <div className="form-group">
            <label className="form-label">{translate("phone")}</label>
            <div className="phone-input-container">
              <div
                className="country-selector"
                onClick={this.toggleCountryDropdown}
                ref={(ref) => {
                  this.countryDropdownRef = ref;
                }}
                style={{ position: "relative" }}
              >
                <span className="flag-icon">
                  {this.getCurrentCountry().flag}
                </span>
                <span className="country-code">
                  {this.getCurrentCountry().dialCode}
                </span>
                <span className="dropdown-arrow">▼</span>
              </div>

              {this.state.showCountryDropdown &&
                ReactDOM.createPortal(
                  <div
                    className="country-dropdown country-dropdown-portal"
                    style={{
                      position: "fixed",
                      top: `${this.state.dropdownPosition.top}px`,
                      left: `${this.state.dropdownPosition.left}px`,
                      zIndex: 2147483647,
                      maxHeight:
                        window.innerWidth <= 768
                          ? `${Math.min(500, window.innerHeight - this.state.dropdownPosition.top + window.scrollY - 20)}px`
                          : "300px",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {this.getCountries().map((country) => (
                      <div
                        key={country.code}
                        className={`country-option ${this.getCurrentCountry().code === country.code ? "selected" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.selectCountry(country);
                        }}
                      >
                        <span className="flag-icon">{country.flag}</span>
                        <span className="country-name">{country.name}</span>
                        <span className="country-code">{country.dialCode}</span>
                      </div>
                    ))}
                  </div>,
                  document.body,
                )}
              <input
                type="tel"
                className="form-input phone-input"
                value={data.celular}
                onChange={(e) =>
                  this.handleInputChange("celular", e.target.value)
                }
                onFocus={this.handleInputFocus}
                onClick={(e) => {
                  e.stopPropagation();
                  e.target.focus();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                  e.target.focus();
                }}
                style={{
                  pointerEvents: "auto",
                  cursor: "text",
                  zIndex: 999999,
                  position: "relative",
                }}
                placeholder="(555) 123-4567"
                required
                readOnly={false}
                disabled={false}
                autoComplete="off"
                ref={(input) => {
                  if (input) {
                    input.disabled = false;
                    input.removeAttribute("disabled");
                  }
                }}
              />
            </div>
          </div>

          <div className="consent-section">
            <input
              type="checkbox"
              id="consentimento"
              className="consent-checkbox"
              checked={data.consentimento || false}
              onChange={this.handleCheckboxChange}
              onClick={(e) => {
                e.stopPropagation();
                e.stopImmediatePropagation();
                // Forçar atualização manual caso o onChange não funcione
                const checked = e.target.checked;
                this.props.onInputChange("step1", "consentimento", checked);

                // Scroll para o botão quando o checkbox for marcado
                if (checked) {
                  this.scrollToButton();
                }
              }}
              style={{
                pointerEvents: "auto",
                cursor: "pointer",
                zIndex: 999999,
                position: "relative",
              }}
              ref={(checkbox) => {
                if (checkbox) {
                  checkbox.disabled = false;
                  checkbox.removeAttribute("disabled");
                }
              }}
            />
            <label htmlFor="consentimento" className="consent-label">
              {translate("consentText")}{" "}
              <a
                href="https://lumos.edu/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="consent-link"
              >
                {translate("privacyPolicy")}
              </a>
              .
            </label>
          </div>

          <button
            type="submit"
            className="continue-button"
            disabled={!data.consentimento}
            onClick={(e) => {
              e.stopPropagation();
              e.stopImmediatePropagation();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            style={{
              pointerEvents: "auto",
              cursor: data.consentimento ? "pointer" : "not-allowed",
              zIndex: 999999,
              position: "relative",
            }}
          >
            {translate("continue")}
          </button>

          {/* Seletor de idiomas temporariamente desabilitado */}
          {/* <div className="language-selector-inline">
            <LanguageSelector />
          </div> */}
        </form>
      </div>
    );
  }
}

export default Step1;
